export const readAuthData = (payload = {}) => {
  const nestedPayload = payload && payload.payload;
  if (nestedPayload && typeof nestedPayload === "object" && !Array.isArray(nestedPayload)) {
    return nestedPayload;
  }
  return payload || {};
};

export const readAuthToken = (payload = {}) => {
  const authData = readAuthData(payload);
  return authData.token || authData.access_token || "";
};

export const buildOtpPayload = (values = {}) => ({
  challenge_id: values.challenge_id || "",
  otp: Array.isArray(values.otp) ? values.otp.join("") : String(values.otp || ""),
});
